import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { HistoryModel, HistoryModelImpl } from './model/history.model';
import { HistoryService, HistoryServiceImpl } from './service/history.service';
import { GetTaskIdDTO, PutHistoryDTO, GetHistoryDetailDTO } from './service/history.repository.interface';
import { GetTaskIdDTOImpl } from './repository/get-task-id.dto';
import { PutHistoryDTOImpl } from './repository/put-history.dto';
import { GetHistoryDetailDTOImpl } from './repository/get-history-detail.dto';

export const HistoryModule = (bind: interfaces.Bind) => {
    bind(HistoryModel).to(HistoryModelImpl);
    bind(HistoryService).to(HistoryServiceImpl);
    bind(GetTaskIdDTO).to(GetTaskIdDTOImpl);
    bind(PutHistoryDTO).to(PutHistoryDTOImpl);
    bind(GetHistoryDetailDTO).to(GetHistoryDetailDTOImpl);
};
